// src/components/strumenti/CoordinamentoDifferenziale.js
// Verifica CEI 64-8 per sistemi TT: la protezione contro i contatti indiretti è coordinata
// se RA × Idn ≤ UL (tensione di contatto limite: 50V nei locali ordinari, 25V nei locali
// particolari/cantieri/ambienti bagnati).
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };
const IDN_COMUNI = [10, 30, 100, 300, 500, 1000];

export default function CoordinamentoDifferenziale() {
  const [resistenzaTerra, setResistenzaTerra] = useState("");
  const [idn, setIdn] = useState("30");
  const [ul, setUl] = useState("50");

  const RA = leggiNumero(resistenzaTerra)||0;
  const Idn = leggiNumero(idn)||0;
  const Ul = leggiNumero(ul)||50;

  const IdnA = Idn/1000; // mA -> A
  const tensioneContatto = RA*IdnA;
  const conforme = RA>0 && tensioneContatto<=Ul;
  const raMassima = IdnA>0 ? Ul/IdnA : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Resistenza di terra misurata RA (Ω)</label>
          <input value={resistenzaTerra} onChange={e=>setResistenzaTerra(e.target.value)} style={inp} placeholder="Es. 15"/>
        </div>
        <div>
          <label style={lbl}>Corrente differenziale Idn</label>
          <select value={idn} onChange={e=>setIdn(e.target.value)} style={inp}>
            {IDN_COMUNI.map(v => <option key={v} value={v}>{v} mA</option>)}
          </select>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Tensione di contatto limite UL</label>
        <select value={ul} onChange={e=>setUl(e.target.value)} style={inp}>
          <option value="50">50 V — locali ordinari</option>
          <option value="25">25 V — locali particolari, cantieri, ambienti bagnati</option>
        </select>
      </div>

      <div style={{ background: RA>0 ? (conforme ? "#f0fdf4" : "#fef2f2") : "#faf5ff", border:`1px solid ${RA>0 ? (conforme?"#bbf7d0":"#fca5a5") : "#e9d5ff"}`, borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", marginBottom: RA>0?10:0, fontSize:11, color:"#6b7280" }}>
          <div style={{textAlign:"center"}}>
            <div>Tensione di contatto (RA × Idn)</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:16}}>{RA>0 ? tensioneContatto.toFixed(1)+" V" : "—"}</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div>RA massima ammessa per questo Idn</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:16}}>{raMassima!==null ? raMassima.toFixed(1)+" Ω" : "—"}</div>
          </div>
        </div>
        {RA>0 && (
          <div style={{ textAlign:"center", borderTop:"1px solid #e5e7eb", paddingTop:10 }}>
            <div style={{ fontSize:18, fontWeight:800, color: conforme ? "#15803d" : "#dc2626" }}>
              {conforme ? "✅ Coordinamento verificato" : "⚠️ Coordinamento NON verificato"}
            </div>
            {!conforme && (
              <div style={{ fontSize:11, color:"#991b1b", marginTop:4 }}>Ridurre la resistenza di terra oppure scegliere un differenziale con Idn più basso</div>
            )}
          </div>
        )}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Verifica secondo CEI 64-8 per sistemi TT (RA × Idn ≤ UL) — non sostituisce la misura strumentale della resistenza di terra né altre verifiche dell'impianto.
      </div>

      <button onClick={()=>{setResistenzaTerra("");setIdn("30");setUl("50");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
